<template>
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        :disabled="tableData.length >= 10"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="要事计划" align="center">
        <!-- 要事类别 -->
        <el-table-column
          prop="mustdoType"
          label="要事类别"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'mustdoType' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.mustdoType"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.mustdoType }}
            </div>
          </template>
        </el-table-column>
        <!-- 工作项 -->
        <el-table-column
          prop="workItem"
          label="工作项"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'workItem' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.workItem"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.workItem }}
            </div>
          </template>
        </el-table-column>
        <!-- 完成日期 -->
        <el-table-column
          prop="completionDate"
          label="完成日期"
          min-width="110px"
          align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-if="
                editField === 'completionDate' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.completionDate"
              type="date"
              placeholder="选择日期"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @change="confirmEdit"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>

            <div v-else>
              {{ scope.row.completionDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="responsiblePerson"
          label="责任人"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'responsiblePerson' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.responsiblePerson"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.responsiblePerson }}
            </div>
          </template>
        </el-table-column>
        <!-- 交付物 -->
        <el-table-column
          prop="deliverables"
          label="交付物"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'deliverables' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.deliverables"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.deliverables }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="里程碑" align="center">
        <!-- 要事进度评价 -->
        <el-table-column
          v-for="(item, index) in milestoneList"
          :key="index"
          :prop="item.field"
          :label="`${item.start} 至 ${item.end}`"
          min-width="210px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === item.field && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row[item.field]"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row[item.field] }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" align="center" width="90px" fixed="right">
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateImportantApi } from "@/api/saleTaskCollection";
import * as moment from "moment";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [],
      milestoneList: [], // 里程碑
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    // 获取里程碑
    getMilestoneList(queryParams) {
      this.milestoneList = [];
      // 获取当前日期
      const today = new Date(queryParams.years, queryParams.months - 1);
      // 开始日期为上月26号
      let currentDate = this.getPreviousMonth26(today);
      // 截止为本月25号
      const endDate = new Date(today.getFullYear(), today.getMonth(), 25);
      // 生成所有周范围
      while (currentDate <= endDate) {
        // 获取本周周日
        const currentSunday = this.getSundayOfCurrentWeek(currentDate);
        // 添加到结果数组
        this.milestoneList.push({
          start: moment(new Date(currentDate)).format("YYYY-MM-DD"),
          end: moment(currentSunday > endDate ? endDate : currentSunday).format(
            "YYYY-MM-DD"
          )
        });
        // 当前日期设置为周天的下一天
        currentDate = new Date(currentSunday);
        currentDate.setDate(currentDate.getDate() + 1);
      }
    },
    // 获取上一个月26号
    getPreviousMonth26(date = new Date()) {
      const prevMonth = new Date(date);
      const currentMonth = date.getMonth();
      prevMonth.setMonth(currentMonth - 1); // 设置为上一个月
      prevMonth.setDate(26); // 设置为上个月的26号
      return prevMonth;
    },
    // 获取当前日期所在周的星期天
    getSundayOfCurrentWeek(dateTime) {
      const today = dateTime ? new Date(dateTime) : new Date();
      // 获取今天是星期几（0 代表星期日，1-6 代表星期一到星期六）
      const dayOfWeek = today.getDay();
      // 计算距离星期天还有几天（如果今天就是星期天，daysUntilSunday 为 0）
      const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
      // 创建一个新的 Date 对象，避免修改原日期
      const sunday = new Date(today);
      // 设置为星期天的日期
      sunday.setDate(today.getDate() + daysUntilSunday);
      return sunday;
    },
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
      this.getMilestoneList(this.queryParams);
      this.milestoneList.map((item, index) => {
        if (index === 0) {
          this.milestoneList[index].field = "milestoneOne";
        }
        if (index === 1) {
          this.milestoneList[index].field = "milestoneTwo";
        }
        if (index === 2) {
          this.milestoneList[index].field = "milestoneThree";
        }
        if (index === 3) {
          this.milestoneList[index].field = "milestoneFour";
        }
        if (index === 4) {
          this.milestoneList[index].field = "milestoneFive";
        }
        if (index === 5) {
          this.milestoneList[index].field = "milestoneSix";
        }
      });
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        mustdoType: "", // 要事类别
        workItem: "", // 工作项
        completionDate: "", // 完成日期
        deliverables: "", // 交付物
        responsiblePerson: "", // 实际交付物
        milestoneOne: "", // 差距描述
        milestoneTwo: "", // 备注
        milestoneThree: "",
        milestoneFour: "",
        milestoneFive: "",
        milestoneSix: ""
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(params) {
      try {
        const submitData = {
          ...params,
          dataList: this.tableData
        };
        const res = await addOrUpdateImportantApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
